import { tradeCondtion } from '@models/BookingInquiry';
import { bookingInquiryProfit } from '@models/BookingInquiryProfit';
import { companyItem } from '@models/Company';
import { instructionStatusName } from '@models/Instruction';
import { preAlertPortFrom, PORT_FROM } from '@models/PreAlertPortFrom';
import { preAlertPortTo, PORT_TO } from '@models/PreAlertPortTo';
import { preAlertVessel, VESSEL_NAMES } from '@models/PreAlertVessel';
import { adminUser } from '@models/User';
import * as t from 'io-ts';
import * as h from 'tyrann-io';

export { preAlertPortFrom, PORT_FROM, preAlertPortTo, PORT_TO, preAlertVessel, VESSEL_NAMES };

export const preAlertPackages = t.union([
  t.literal(''),
  t.literal('BUNDLE'),
  t.literal('BAG'),
  t.literal('BALE'),
  t.literal('BOX'),
  t.literal('CAN'),
  t.literal('CAGE'),
  t.literal('COIL'),
  t.literal('CASE'),
  t.literal('CARTON'),
  t.literal('DRUM'),
  t.literal('FIBRE'),
  t.literal('FLEX'),
  t.literal('PARCEL'),
  t.literal('PACKAGE'),
  t.literal('PALLET'),
  t.literal('PIECE'),
  t.literal('REEL'),
  t.literal('ROLL'),
  t.literal('SET'),
  t.literal('STEEL'),
]);

export const PACKAGES = preAlertPackages.types.map((type) => type.value);

export const preAlertDetails = t.type({
  no: t.string,
  created_at: t.string,
  shipper: t.string,
  vessel: t.string,
  voyage: t.string,
  pod: t.string,
  pol: t.string,
  etd: h.omittable(t.string),
  eta: h.omittable(t.string),
  atd: h.omittable(t.string),
  ata: h.omittable(t.string),
  quantity: h.omittable(t.number),
  gross_weight: h.omittable(t.string),
  measurement: h.omittable(t.string),
  refer_number: h.omittable(t.string),
  consignee: t.string,
  house_bl_number: t.string,
  packages: t.string,
  shipping_mark: t.string,
  commodity: t.string,
  payments_terms: t.string,
  updated_at: t.string,
  booking_inquiry: t.number,
  is_empty: t.boolean,
  is_manually_locked: t.boolean,
  is_ledger_locked: t.boolean,
  customer_no: t.string,
  job_code: t.string,
  sea_waybill_id: h.omittable(t.number),
  arrival_notice_id: h.omittable(t.number),
  delivery_guidance_id: h.omittable(t.string),
  carrier: h.omittable(t.string),
  vessel_schedule: h.omittable(t.number),
  exchange_rate: h.omittable(h.string()),
  overseas_local_amount: h.omittableString(),
  minimum_etd: h.omittable(h.string()),
  profit: h.omittable(bookingInquiryProfit),
});

export type PreAlertDetails = t.TypeOf<typeof preAlertDetails>;

export const putPreAlert = t.type({
  refer_number: h.omittable(t.string),
  vessel: t.string,
  voyage: t.string,
  quantity: t.number,
  packages: t.string,
  shipping_mark: t.string,
  commodity: t.string,
  gross_weight: t.string,
  measurement: t.string,
  payments_terms: t.string,
  vessel_schedule: h.omittable(t.number),
});

export type PutPreAlert = t.TypeOf<typeof putPreAlert>;

export const patchPreAlert = t.type({
  detail: t.string,
  refer_number: h.omittable(t.string),
  shipper: h.omittable(t.string),
  consignee: h.omittable(t.string),
  house_bl_number: h.omittable(t.string),
  vessel: h.omittable(preAlertVessel),
  voyage: h.omittable(t.string),
  port_from: h.omittable(preAlertPortFrom),
  port_to: h.omittable(preAlertPortTo),
  etd: h.omittable(t.string),
  eta: h.omittable(t.string),
  quantity: h.omittable(t.number),
  packages: h.omittable(preAlertPackages),
  shipping_mark: h.omittable(t.string),
  commodity: h.omittable(t.string),
  gross_weight: h.omittable(t.number),
  measurement: h.omittable(t.number),
  payments_terms: h.omittable(tradeCondtion),
  vessel_schedule: h.omittable(t.number),
  is_manually_locked: h.omittable(t.boolean),
});

export type PatchPreAlert = t.TypeOf<typeof patchPreAlert>;

export const patchPreAlertError = t.type({
  detail: h.omittable(t.array(t.string)),
  refer_number: h.omittable(t.array(t.string)),
  shipper: h.omittable(t.array(t.string)),
  consignee: h.omittable(t.array(t.string)),
  house_bl_number: h.omittable(t.array(t.string)),
  vessel: h.omittable(t.array(t.string)),
  voyage: h.omittable(t.array(t.string)),
  port_from: h.omittable(t.array(t.string)),
  port_to: h.omittable(t.array(t.string)),
  etd: h.omittable(t.array(t.string)),
  eta: h.omittable(t.array(t.string)),
  quantity: h.omittable(t.array(t.string)),
  packages: h.omittable(t.array(t.string)),
  shipping_mark: h.omittable(t.array(t.string)),
  commodity: h.omittable(t.array(t.string)),
  gross_weight: h.omittable(t.array(t.string)),
  measurement: h.omittable(t.array(t.string)),
  payments_terms: h.omittable(t.array(t.string)),
});

export const preAlert = t.type({
  id: t.number,
  no: t.string,
  d2d_no: t.string,
  created_at: h.omittable(t.string),
  customer_no: h.omittable(t.string),
  fc_manager: h.omittable(t.string),
  type: h.omittable(t.string),
  shipper: h.omittable(t.string),
  status: h.omittable(t.string),
  transport_status: h.omittable(t.string),
  vessel: h.omittable(t.string),
  voyage: h.omittable(t.string),
  pol: h.omittable(t.string),
  etd: h.omittable(t.string),
  pod: h.omittable(t.string),
  eta: h.omittable(t.string),
  quantity: h.omittable(t.number),
  commodity: h.omittable(t.string),
  gross_weight: h.omittable(t.string),
  measurement: h.omittable(t.string),
  delivery_date: h.omittable(t.string),
  invoice_price: h.number().cast(),
  is_empty: h.boolean(),
});

export type PreAlert = t.TypeOf<typeof preAlert>;

export const dashboardPreAlert = t.type({
  id: t.number,
  no: t.string,
  d2d_no: t.string,
  created_at: h.omittable(t.string),
  english_name: t.string,
  company_name: h.omittable(t.string),
  type: h.omittable(t.string),
  status: h.omittable(t.string),
  transport_status: h.omittable(t.string),
  member_salesperson: h.omittable(t.string),
  member_salesperson_last_name: h.omittable(t.string),
  salesperson_china_name: h.omittable(t.string),
  salesperson_china_last_name: h.omittable(t.string),
  salesperson_japan_name: h.omittable(t.string),
  salesperson_japan_last_name: h.omittable(t.string),
  salesperson_customs_name: h.omittable(t.string),
  salesperson_customs_last_name: h.omittable(t.string),
  consignee: h.omittable(t.string),
  source: t.union([t.literal('admin'), t.literal('client')]),
  etd: h.omittable(t.string),
  eta: h.omittable(t.string),
  vessel: h.omittable(t.string),
  pod: h.omittable(t.string),
  pol: h.omittable(t.string),
  owner: h.omittable(adminUser),
  owner_company: h.omittable(companyItem),
  user: h.omittable(adminUser),
  trade_condition: tradeCondtion,
  has_pickups: t.boolean,
  agency_name: h.omittable(t.string),
  shipper: h.omittable(t.string),
  is_empty: h.omittable(t.boolean),
  quantity: h.omittable(t.number),
  measurement: h.omittable(t.string),
  gross_weight: h.omittable(t.string),
  is_manually_locked: h.omittable(t.boolean),
  customs_instruction_status: h.omittable(instructionStatusName),
  delivery_instruction_status: h.omittable(instructionStatusName),
  customs_request_status: h.omittable(t.string),
  delivery_request_status: h.omittable(t.string),
  do_status: h.omittable(t.string),
  move_out_status: h.omittable(t.string),
  invoice_status: h.omittable(t.string),
  payment_slip_status: h.omittable(t.string),
  profit: h.omittable(bookingInquiryProfit),
  cancel_detail: h.omittable(t.string),
  delivery_date: h.omittable(t.string),
});

export type DashboardPreAlert = t.TypeOf<typeof dashboardPreAlert>;

export const preAlertPages = t.type({
  count: t.number,
  previous: t.union([t.string, t.null]),
  next: t.union([t.string, t.null]),
  results: t.array(preAlert),
});

export const dashboardPreAlertPages = t.type({
  count: t.number,
  previous: t.union([t.string, t.null]),
  next: t.union([t.string, t.null]),
  results: t.array(dashboardPreAlert),
});

export const preAlertTypeType = t.union([
  t.literal('current'),
  t.literal('past_canceled'),
  t.literal('past_finished'),
]);

export type PreAlertTypeType = t.TypeOf<typeof preAlertTypeType>;

export const preAlertQuery = t.partial({
  page: t.number,
  d2d_no: t.string,
  ordering: t.union([t.literal('-created_at'), t.literal('created_at')]),
  vessel: t.string,
  type: t.array(preAlertTypeType),
});

export type PreAlertQuery = t.TypeOf<typeof preAlertQuery>;

export const dashboardPreAlertQuery = t.partial({
  agency_id: h.number().cast(),
  company_name: t.string,
  created_at_after: t.string,
  created_at_before: t.string,
  d2d_no: t.string,
  etd_after: t.string,
  etd_before: t.string,
  eta_after: t.string,
  eta_before: t.string,
  preferred_arrival_date_after: t.string,
  preferred_arrival_date_before: t.string,
  member_no: t.string,
  ordering: t.string,
  page: t.number,
  page_size: h.omittableNumber().cast(),
  pod: h.array(t.string),
  pol: h.array(t.string),
  trade_condition: t.string,
  transport_status: t.string,
  customs_instruction_status: instructionStatusName,
  delivery_instruction_status: instructionStatusName,
  member_salesperson: t.string,
  salesperson_china: h.string(),
  salesperson_japan: h.string(),
  member_salesperson_id: h.number().cast(),
  salesperson_china_id: h.number().cast(),
  salesperson_japan_id: h.number().cast(),
  salesperson_customs_id: h.number().cast(),
  has_salesperson_china: h.boolean().cast(),
  has_salesperson_japan: h.boolean().cast(),
  has_salesperson_customs: h.boolean().cast(),
  has_pickups: h.boolean().cast(),
  vessel: t.string,
  consignee: t.string,
  email: h.string(),
  fullname: h.string(),
  before_departure: h.boolean().cast(),
  is_empty: t.string,
  type: t.array(preAlertTypeType),
  customs_request_status: t.union([t.string, t.null]),
  delivery_request_status: t.union([t.string, t.null]),
  invoice_status: t.string,
  payment_slip_status: t.string,
  do_status: t.string,
  move_out_status: t.string,
});

export type DashboardPreAlertQuery = t.TypeOf<typeof dashboardPreAlertQuery>;

export const dashboardPreAlertSearchType = t.partial({
  ...dashboardPreAlertQuery.props,
  has_pickups: h.boolean().booleanish(),
  before_departure: h.boolean().booleanish(),
  checklist: t.array(h.string()),
});

export const bookingDetailsTypeType = t.union([...preAlertTypeType.types, t.literal('all')]);

export const bookingDetailsSearchType = t.type({
  d2dNo: h.string(),
  type: bookingDetailsTypeType,
  tabActiveId: h.omittableString(),
});
